/**
 * DOM id sidra za HomePage sekcije (CTA / scroll-spy / notification deep links).
 * Živi u shared da notification registry ne uvozi features.
 */
export const HOME_SECTION_IDS = Object.freeze({
  OBJAVE: 'home-section-objave',
  POU: 'home-section-pou',
  IMPLEMENTATION: 'home-section-implementation',
  PLANNING: 'home-section-planning',
  ARCHIVE: 'home-section-archive',
});
